// extracted by mini-css-extract-plugin
export default {"replicatedCount":"styles_replicatedCount__H1Xp8","tabList":"styles_tabList__eedTo","tabFilter":"styles_tabFilter__jcVsE"};